import Header from "./HubungiKami/Header";

function Index() {
    return (
        <div className={"max-w-screen-2xl flex flex-col space-y-16 lg:space-y-20 mx-auto"}>
            <Header/>
        </div>
    );
}

export default Index;
